export const ENV_CONFIG = window.__GDY_ENV_CONFIG__ || {};
